'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const OfficeMap = dynamic(() => import('./OfficeMap'), {
  ssr: false,
  loading: () => (
    <div className="w-full min-w-[768px] h-[420px] md:min-w-0 md:h-[520px] lg:h-[650px] xl:h-[719px] rounded-lg bg-gray-100 animate-pulse" />
  ),
});

const DesktopOfficeMap: React.FC = () => {
  return (
    <div className="hidden xl:block w-full pb-4">
      <div className="relative z-0 w-full h-[650px] xl:h-[719px] max-w-[1360px] mx-auto">
        <OfficeMap className="w-full h-full" />
      </div>
    </div>
  );
};

export default DesktopOfficeMap;
